export default __webpack_public_path__ + "8fb266683ac9b4f8a29808ba8480ec6e.woff2";